import React from "react";
import GlobalContext from "../GlobalContext";
import he from 'he';
import { NavLink } from "react-router-dom";

import "./CategoriesList.css";

function CategoriesList() {
  const global = React.useContext(GlobalContext);

  if (!global.state.initialized || global.state.error) return false;

  return (
    <div className="categories-list">
      <ul>
      {global.state.filterCategories.map(category => (
        <li key={category.id}>
          <NavLink to={`/${category.slug}`}><h3>{he.decode(category.name)}</h3></NavLink>
          {category.children && category.children.length > 0 && (
            <p>
              {category.children.map((subCategory, index) => (
                <React.Fragment key={subCategory.id}>
                  <NavLink to={`/${subCategory.slug}`}>{he.decode(subCategory.name)}</NavLink>
                  {index < category.children.length - 1 && ', '}
                </React.Fragment>
              ))}
            </p>
          )}
        </li>
      ))}
    </ul>
    </div>
  );
}

export default CategoriesList;